"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var optionFilterList = [
    { filter: 'Género', key: 'gender', value: 'Masculino', dbKey: 'M' },
    { filter: 'Género', key: 'gender', value: 'Femenino', dbKey: 'F' },
    { filter: 'Estado', key: 'status', value: 'Activo', dbKey: 'ACTIVE' },
    { filter: 'Estado', key: 'status', value: 'Inactivo', dbKey: 'INACTIVE' },
];
exports.default = optionFilterList;
